module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2a3ba1084cca0bc13b8879eeb87c7640.png";